<template>
  <div class="app">
    <Loading :value="loading"></Loading>
    <!-- MODAL DETAILS DE COMMANDE -->
    <v-dialog v-model="dialogModalCommandeMAJ" max-width="80%" :overlay="true" scrollable persistent>
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Détails de la commande</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeDialog()" dark><v-icon>close</v-icon> </v-btn>
        </v-toolbar>

        <v-card-text>
          <p align="center">
            <v-chip text-color="white" label color="primary" style="width:100%">
              DETAILS DE LA COMMANDE <v-icon right>shopping_cart</v-icon>
            </v-chip>
          </p>

          <v-form v-model="valid" lazy-validation id="formComm" ref="formComm">
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex md4>
                  <span class="demonstration">Fournisseur</span>
                    <el-select :disabled="true" v-model="fournisseurCommandeId" placeholder="Fournisseur" name="fournisseur" style="width:100%">
                      <el-option v-for="item in listFournisseur"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id">
                      </el-option>
                    </el-select>
                </v-flex>
                <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Intitulé de la commande</span>
                    <el-input name="libelle" placeholder="Intitulé de la commande" v-model="libelleCommande" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <!-- <v-flex md4>
                  <div class="block">
                    <span class="demonstration">Date de livraison</span>
                    <el-date-picker v-model="dateLivraison" name="dateLivraison" id="dateLivraison" value-format="dd-MM-yyyy" value="dd-MM-yyyy" type="date" placeholder="Date de livraison" style="width: 100%"></el-date-picker>
                  </div>
                </v-flex> -->
                <v-flex md3>
                  <div class="block">
                  <span class="demonstration">Priorité</span>
                    <el-select :disabled="true" v-model="prioriteCommande" :trigger-on-focus="true">
                        <el-option v-for="priorite in priorites"
                          :key="priorite.value"
                          :label="priorite.label"
                          :value="priorite.value"
                        >
                        </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>

               <!-- MAINTENANCE -->

                <v-layout  v-if="detailCommande && detailCommande.entrepotId"  row>
                <v-flex md12>
                    <div class="block">
                        <span class="demonstration">Magasin chantier</span>
                        <el-input v-model="detailCommande.libEntrepot"  placeholder="maintenance" style="width: 100%" :readonly="true"></el-input>
                    </div>
                </v-flex>
              </v-layout>

              <v-layout v-if="detailCommande && detailCommande.projetId" row>
                   <v-flex md4>
                        <div class="block">
                            <span class="demonstration">Projet concerné </span>
                            <el-select filterable v-on:change="loadChantier()" v-model="projetS" placeholder="Type de Projet" style="width:100%">
                                <el-option v-for="item in listeProjet" :key="item.id" :label="item.libelle" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </v-flex>
                    <v-flex md4>
                        <div class="block">
                            <span class="demonstration">Chantier concerné </span>
                            <el-select filterable v-on:change="loadTravaux()" v-model="chantierS" placeholder="Chantier concerné" style="width:100%">
                                <el-option v-for="item in listeChantier" :key="item.id" :label="item.libelle" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </v-flex>
                    <v-flex md4>
                         <div class="block">
                            <span class="demonstration">Travaux </span>
                            <el-select filterable v-model="travauxS" placeholder="Travaux" style="width:100%">
                                <el-option v-for="item in listeTravaux" :key="item.id" :label="item.libelle" :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                    </v-flex>
                </v-layout>

              <p align="center">
                <v-chip outline text-color="primary" label color="primary" style="width:100%">
                  PRODUIT(S) LIE(S) A LA COMMANDE <v-icon right>shopping_cart</v-icon>
                </v-chip>
              </p>

              <v-layout row v-for="besoin in optionCommande" :key="besoin.key">
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Ressource</span>
                    <el-input v-model="besoin.produit" name="produit" placeholder="Ressource" style="width: 100%" :readonly="true"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Quantité</span>
                    <el-input type="number" value="qte" placeholder="Quantité" v-model="besoin.qte" style="width:100%"></el-input>
                  </div>
                </v-flex>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Unité</span>
                    <el-input class="inline-input" v-model="besoin.unite" :trigger-on-focus="true" style="width: 100%" :readonly="true"></el-input>
                  </div>
                </v-flex>

                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Priorité</span>
                    <el-input v-if="besoin.priorite==1" value="Faible" :trigger-on-focus="true" :readonly="true"></el-input>
                    <el-input v-else-if="besoin.priorite==2" value="Normal" :trigger-on-focus="true" :readonly="true"></el-input>
                    <el-input v-else-if="besoin.priorite==3" value="Urgent" :trigger-on-focus="true" :readonly="true"></el-input>
                    <el-input v-else value="Aucune" :trigger-on-focus="true" :readonly="true"></el-input>
                </div>
                </v-flex>

                <v-flex md1>
                  <v-tooltip top>
                    <v-btn slot="activator" @click.prevent="removeOptionBesoin(besoin)" fab dark small color="red" v-show="tailleOptionBesoinSupUn && besoin.besoinId!=null">
                      <v-icon dark>delete</v-icon>
                    </v-btn>
                    Supprimer
                  </v-tooltip>
                </v-flex>
              </v-layout>
              <br>
            </v-container>

            <v-btn @click="closeDialog()" color="red" dark>Annuler<v-icon right>close</v-icon></v-btn>
            <v-btn icons color="primary" @click="updateCommande()" dark>Modifier<v-icon right>edit</v-icon></v-btn>
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import Loading from '@/components/Loading';

  export default {
      components: {Loading},
      name: "ModalCommandeMAJ",
      props: ["show","detailCommande"],

    data() {
      return {

        domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
        user: JSON.parse(sessionStorage.getItem("userInfo")),
        roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
        loading: false,

        fournisseur:null,
        priorite:1,
        dateLivraison:null,
        valid:true,
        libelleCommande:"",
        prioriteCommande:1,
        idCommande:0,
        fournisseurCommande:null,
        dialogDetailCommande:false,
        listFournisseur:[],
        dialogModalCommandeMAJ:false,
        tailleOptionBesoinSupUn:false,
        optionBesoinIndexDeleted:[],
        optionCommandeIdDeleted:[],
        fournisseurCommandeId:null,
        optionCommande: [{
           key: 1,
           produit: '',
           qte: 1,
           unite: '',
           id: 0,
           priorite:1
           }],
        priorites:[
            {
                value:1,
                label:"Faible"
            },
            {
                value:2,
                label:"Normal"
            },
            {
                value:3,
                label:"Urgent"
            }
          ],
           //Projet
            listeProjet:[],
            listeChantier:[],
            listeTravaux:[],
            projetS: '',
            chantierS: '',
            travauxS: '',
        }
    },

    computed: {
    },

    methods: {

          loadFournisseur () {
            this.loading = true
            let url = this.domaine + 'fournisseur/index'
            this.$http.get(url).then(response => {
              if (response.body) {
                this.listFournisseur = response.body.fournisseur
                this.loading = false
              }
            })
          },

          updateCommande () {
            this.loading = true
            if (this.$refs.formComm.validate() && this.libelleCommande != ""  && this.fournisseurCommande != null && this.prioriteCommande>0) {

              var formdata = new FormData()
              let url = this.domaine + 'besoin/update/commande'

              //recupération des informations des options besoins
              for(let i in this.optionBesoinIndexDeleted){
                formdata.append('optionBesoin[]', this.optionBesoinIndexDeleted[i]);
                formdata.append('optionCommande[]', this.optionCommandeIdDeleted[i]);
              }

              formdata.append('idCommande', this.idCommande);
              formdata.append('libelle', this.libelleCommande);
              formdata.append('priorite', this.prioriteCommande);
              formdata.append('dateLivraison', this.dateLivraison);
              formdata.append('idUserModifier', this.user.id);
              formdata.append('fournisseur', this.fournisseurCommandeId);

              formdata.append('projetId', this.projetS)
              formdata.append('chantierId', this.chantierS)
              formdata.append('travauxId', this.travauxS)

              this.$http.post(url, formdata).then(response => {
                if (response.body) {
                  let verif = response.body
                  if (verif.code === 1) {
                    this.$notify({
                      title: 'MISE A JOUR',
                      message: 'Mise à jour de la commande réussi',
                      type: 'success',
                      position: 'top-center'
                    });
                    this.closeDialog();
                    this.loading = false
                    this.$refs.formComm.reset()
                  } else if (verif.code === 2) {
                    this.$message.error(verif.message)
                    this.loading = false
                  }
                } else {
                  this.$message.error('Erreur serveur')
                  this.loading = false
                }
              },
              response => {
                this.$message.error('Erreur serveur')
                this.loading = false
              })

            } else {
              this.$message.error('Veuillez renseigner les champs obligatoires')
              this.$notify.error({
                title: "ERREUR D'ENREGISTREMENT",
                message: "La commande n'a pas été mise a jour!",
                position: 'top-center'
              })
              this.loading = false
            }
          },

          removeOptionBesoin (item) {
            this.$confirm('Si vous continuez, ce produit sera supprimer après avoir cliqué sur modifier?', 'Attention', {
                confirmButtonText: 'Continuer',
                cancelButtonText: 'Annuler',
                type: 'warning'
              }).then(() => {

                //sauvegarde de l'index du produit concerné et de l'option commande a supprimer
                this.optionBesoinIndexDeleted.push(item.besoinId);
                this.optionCommandeIdDeleted.push(item.id);

                const index = this.optionCommande.indexOf(item);

                if (index !== -1) {
                  this.optionCommande.splice(index, 1)
                }
                this.tailleOptionBesoinSupUn=this.optionCommande.length>1?true:false;

              }).catch(() => {
                this.$message({
                  type: 'info',
                  message: 'Action annulée'
                });
                this.loading=false;
              });
          },

           loadProjet ()
          {
              let url = this.domaine + 'projet/index/projet/all'
              this.loading = true
              this.$http.get(url).then(response => {
                  this.loading = false
                      this.listeProjet = response.body.projet
                      this.projetS = this.detailCommande.projetId;
              },errRep=>{
                   this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la liste des projets")
              })
          },

            loadChantier ()
            {
              this.loading =  true
              let url = this.domaine + 'projet/'+ this.projetS +'/index/chantier'
              this.$http.get(url).then(response => {
                  this.loading = false
                  this.listeChantier = response.body.chantier
                   this.chantierS = this.detailCommande.chantierId;
              },errRep=>{
                   this.loading = false
                  this.$message.error("Une erreur est survenue lors du chargement de la liste du chntier")
              })
          },

          loadDetailsCommande() {
            //transfert des données du tableau de detail de commande
            this.optionCommande=this.detailCommande.option;
            this.idCommande=this.detailCommande.id;
            this.libelleCommande=this.detailCommande.libelle;
            this.prioriteCommande=this.detailCommande.priorite;
            this.dateLivraison=this.detailCommande.dateLivr;
            this.fournisseurCommande=this.detailCommande.fournisseurNom;
            this.fournisseurCommandeId=this.detailCommande.fournisseur;

            //projet
            this.projetS = this.detailCommande.projetId;
            this.chantierS = this.detailCommande.chantierId;
            this.travauxS = this.detailCommande.travauxId;

            console.log("travaux")
            console.log(this.travauxS)

            //controle du nombre de produit formant la commande
            this.tailleOptionBesoinSupUn=this.optionCommande.length>1?true:false;
          },
            loadTravaux ()
            {
                this.loading = true
                this.travauxS = ''
                this.listTravaux = []
                if (this.chantierS !== '') {
                    let url = this.domaine + 'projet/'+ this.chantierS +'/index/chantier/travaux'
                    this.$http.get(url).then(response => {
                        if (response.body) {
                            console.log("load travaux")
                            console.log( this.travauxS)
                            this.listeTravaux = response.body.travaux
                             this.travauxS = this.detailCommande.travauxId;
                            this.loading = false
                        }
                    })
                } else {
                    this.$message.error('Veuillez sélectionner un chantier')
                    this.loading = false
                }
            },

          closeDialog()
          {
              this.$emit('close')
          }
        },

    watch: {
            show : function(newValue, oldvalue){
                if(newValue == true){
                  this.loadDetailsCommande();
                  this.loadFournisseur();

                  if(this.detailCommande.projetId){
                     this.loadProjet();
                     this.loadChantier();
                     this.loadTravaux();
                  }


                  //suppression des elements du tableau d'indice de besoin
                  this.optionBesoinIndexDeleted=[];
                }
                this.dialogModalCommandeMAJ = newValue
            }
        },
  };
</script>



// WEBPACK FOOTER //
// src/components/besoin/ModalCommandeMAJ.vue